/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ReactivateUsersOptions,
  ReactivateUsersStatus200,
  ReactivateUsersStatus400,
  ReactivateUsersStatus403,
  ReactivateUsersStatus404,
  ReactivateUsersStatus500,
} from '../types/ReactivateUsers'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { reactivateUsers } from '../clients/reactivateUsers'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const reactivateUsersMutationKey = () => [{ url: '/v1/user/reactivate' }] as const

export function reactivateUsersMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = reactivateUsersMutationKey()
  return mutationOptions<
    ReactivateUsersStatus200,
    ResponseErrorConfig<
      | ReactivateUsersStatus400
      | ReactivateUsersStatus403
      | ReactivateUsersStatus404
      | ReactivateUsersStatus500
    >,
    ReactivateUsersOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return reactivateUsers({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Bulk form of POST /v1/user/{user_id}/reactivate. Admin may target tenant_id, trading_challenge_id, or explicit user_ids. COMPETITION_MANAGER may only target one assigned trading_challenge_id and their users (no tenant_id). Each user is processed independently: the response reports, per user, either the REACTIVATED request or the reason it was rejected. Duplicate user IDs collapse into one result.
 * @summary Lift multiple users' account deactivations (admin or scoped competition manager)
 * {@link /v1/user/reactivate}
 */
export function useReactivateUsers<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ReactivateUsersStatus200,
      ResponseErrorConfig<
        | ReactivateUsersStatus400
        | ReactivateUsersStatus403
        | ReactivateUsersStatus404
        | ReactivateUsersStatus500
      >,
      ReactivateUsersOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? reactivateUsersMutationKey()

  const baseOptions = reactivateUsersMutationOptions(config) as UseMutationOptions<
    ReactivateUsersStatus200,
    ResponseErrorConfig<
      | ReactivateUsersStatus400
      | ReactivateUsersStatus403
      | ReactivateUsersStatus404
      | ReactivateUsersStatus500
    >,
    ReactivateUsersOptions,
    TContext
  >

  return useMutation<
    ReactivateUsersStatus200,
    ResponseErrorConfig<
      | ReactivateUsersStatus400
      | ReactivateUsersStatus403
      | ReactivateUsersStatus404
      | ReactivateUsersStatus500
    >,
    ReactivateUsersOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ReactivateUsersStatus200,
    ResponseErrorConfig<
      | ReactivateUsersStatus400
      | ReactivateUsersStatus403
      | ReactivateUsersStatus404
      | ReactivateUsersStatus500
    >,
    ReactivateUsersOptions,
    TContext
  >
}
